/**
 * @prettier
 */

import React from 'react';
import { connect } from 'react-redux';
import { Link } from '@zola/zola-ui/src/components/Link';
import CardCorrectionReview from '../../CardCorrectionReview/CardCorrectionReview';
import { getPageData } from '../../../../reducers/pdp/selectors';
import FeatureFlags from '../../../../../util/featureFlags';
import OtherThingsToReview from './OtherThingsToReview';
import './TipsModals.less';

export function TipCTDFrontWithoutLinks() {
  return (
    <div className="etiquette-tip-modal">
      <div className="tip-content-container">
        <div className="modal-body" style={{ paddingBottom: 0, marginBottom: '-30px' }}>
          <h3>What to Include on Change the Dates</h3>
          <div className="section">
            <p className="desc">
              Changing your plans is a difficult decision. But know that your friends, family, and
              community will support you through it all. Here are a few tips for sharing the news.
            </p>
            <ul className="desc">
              <li>Add your names. A photo is also nice, but not expected.</li>
              <li>
                Share the new date or, if you’re still working out the logistics, try a phrase like
                “we will keep you updated regarding our wedding details.”
              </li>
              <li>Remind guests of the city and state of your wedding location.</li>
              <li>Write a brief (brief!) personal message. For templates, check out our guide.</li>
              <li>Indicate if you’ll be following up with invitations.</li>
              <li>
                Direct guests to your wedding website for more details. Don’t forget to share your
                password if you have one!
              </li>
            </ul>
          </div>
        </div>
      </div>
      <OtherThingsToReview />
    </div>
  );
}

export function TipCTDFrontWithLinksBase({ pageData }) {
  const themeKey = pageData && pageData.websiteTheme && pageData.websiteTheme.key;
  const websiteRoute = themeKey ? `/design/${themeKey}` : '';
  return (
    <div className="etiquette-tip-modal">
      <div className="tip-content-container">
        <div className="modal-body" style={{ paddingBottom: 0, marginBottom: '-30px' }}>
          <CardCorrectionReview.Title>
            What to Include on Change the Dates
          </CardCorrectionReview.Title>
          <div className="section">
            <p className="desc">
              Changing your plans is a difficult decision. But know that your friends, family, and
              community will support you through it all. Here are a few tips for sharing the news.
            </p>
            <ul className="desc">
              <li>Add your names. A photo is also nice, but not expected.</li>
              <li>
                Share the new date or, if you’re still working out the logistics, try a phrase like
                “we will keep you updated regarding our wedding details.”
              </li>
              <li>Remind guests of the city and state of your wedding location.</li>
              <li>Write a brief (brief!) personal message. For templates, check out our guide.</li>
              <li>Indicate if you’ll be following up with invitations.</li>
              <li>
                <span>Direct guests to your </span>
                <Link inline target="_blank" href={`/wedding/manage/website${websiteRoute}`}>
                  wedding website
                </Link>
                <span> for more details. Don’t forget to share your password if you have one!</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <OtherThingsToReview />
    </div>
  );
}

export const mapStateToProps = state => ({
  pageData: getPageData(state),
});

export const TipCTDFrontWithLinks = connect(mapStateToProps)(TipCTDFrontWithLinksBase);

const TipCTDFrontSwitch = () => {
  if (FeatureFlags.get('invitesTipModalsWithLinks')) {
    return <TipCTDFrontWithLinks />;
  }

  return <TipCTDFrontWithoutLinks />;
};

export default TipCTDFrontSwitch;
